// Страница вопросов /faq (макет v73, доска «Вопросы · /faq»): разделы «Фигурка в подарок» и
// «Миниатюра для игры». Вопросы — те же, что на витринах, из одного модуля site/faq.
import { GIFT_FAQ, MINI_FAQ } from "../../site/faq";
import { SiteFooter } from "../../site/SiteFooter";
import { SiteHeader } from "../../site/SiteHeader";
import { FaqList, ShowcaseSection } from "../showcase/ShowcaseParts";
import styles from "../showcase/Showcase.module.css";

export function FaqScreen() {
  return (
    <div className={styles.page}>
      <SiteHeader />
      <main className={styles.main}>
        <section className={styles.hero}>
          <h1 className="h1">Вопросы</h1>
        </section>
        <ShowcaseSection title="Фигурка в подарок" id="gift">
          <FaqList items={GIFT_FAQ} />
        </ShowcaseSection>
        <ShowcaseSection title="Миниатюра для игры" id="mini">
          <FaqList items={MINI_FAQ} />
        </ShowcaseSection>
      </main>
      <SiteFooter />
    </div>
  );
}
